import { Constants } from "../constants/Variables"
import {data as statemap_json} from "../data/states_2020"
import {data as districtmap_json} from "../data/districts_2011"
import _ from "lodash"
import { checkYearWiseStateValidity } from "../utils/helper"
const timezone_suffix=' 00:00:00'

/**
 * Processes filter data for visualization components
 * Data Manipulation:
 * - Extracts and formats date ranges
 * - Converts dates to year lists
 * - Handles special case for "all" in sectors
 * 
 * @param {Object} filteredsearchid - Contains filter parameters
 * @param {Array} filteredsearchid.all_dates - Array of dates
 * @param {Array} filteredsearchid.all_sectors - Array of sectors
 * @returns {Object} - Processed filter data with years and sectors
 */
const parseFilters = async (filteredsearchid) => {
    var date_filter =  filteredsearchid["all_dates"];
    if(date_filter){
        var minyear = new Date(date_filter[0]?.concat(timezone_suffix)); // Getting the first date of the array and parsing its year serving as minyear
        var maxyear = new Date(date_filter[date_filter?.length-1].concat(timezone_suffix)); // Getting the last date of the array and parsing its year serving as maxyear
    }
    let year_list = [];
    let date_list = {};
    var i = 0;
    // Creating an array for all the years present in the date array serving as our values for year slider for visualizations.
    date_filter?.forEach((value) => {
      var d = new Date(value.concat(timezone_suffix));
      year_list[i] = d.getFullYear();
      date_list[d.getFullYear()] = value;
      i++;  
    });
    let current_year_var = maxyear?.getFullYear(); // Always considering the max year as our initial year and according data to be rendered on the first load of SEDP
    
    // this segment of code searches for "total" key in the all_ sector array and shifts that particular array from its searched index to the starting of the array
    // to achieve a sorted array that has "total" in the beginning
    var tru_filter = filteredsearchid['all_sectors'];
    if(_isContains(tru_filter, "all")){
        let index = await tru_filter.findIndex(function (element) { 
            return element === "all";
        });
        let element = tru_filter.splice(index, 1)[0]; // removes the key from the searched index
        tru_filter.splice(0, 0, element); // shifts the removed key to the starting of the array
    }

    return {
        "curr_year": current_year_var,
        "minyear": minyear,
        "maxyear": maxyear,
        "year_list": year_list,
        "tru_filter": tru_filter,
        "all_facets": filteredsearchid['all_facets'],
        "other_filters": filteredsearchid['unique_facets']
    };
}

/**
 * Maps state and district codes to their names
 * Data Manipulation:
 * - Extracts state names from state map JSON
 * - Filters and maps district names based on selected state
 * - Creates lookup objects for state and district names
 * 
 * @param {string} selectedStateCode - Selected state code for filtering districts
 * @returns {Object} - Mapped state and district names along with district statenames.
 */
const parseEntityNames = async (selectedStateCode, selectedYear, visualization=Constants.Map) => {
    var statenames = {}, districtnames={}, district_statenames={};

    // iterates over statemap_json file to get statecodes(as keys) and corresponding statenames(as values) and saves it in statenames object
    Object.keys(statemap_json.features).forEach(async (key) => {
        let value = statemap_json.features[key];
        if(visualization===Constants.Line){
            statenames[value.properties.state_code] = value.properties.state_name;
        }
        else if(checkYearWiseStateValidity(selectedYear, value.properties.state_code, visualization)){
            statenames[value.properties.state_code] = value.properties.state_name;
        }
    })
    if(selectedStateCode){
        /* iterates over districtmap_json file and if selectedstatecode is matched with the corresponding item's state_code,
        then districtnames object is created with district_code(as keys) and corresponding districtnames(as values).
        simultaneously creates another district_statenames object with district_code(as keys) and state_name(as values) */
        Object.keys(districtmap_json.objects.districts_2011.geometries).forEach(key => {
            let value = districtmap_json.objects.districts_2011.geometries[key];
            if(selectedYear>=2020 && parseInt(selectedStateCode)===38 && value.properties.state_code === 1 && (value.properties.district_code===3 || value.properties.district_code===4)){
                districtnames[value.properties.district_code] = value.properties.district_name;
                district_statenames[value.properties.district_code] = 'Ladakh';
            }
            else if(selectedYear>=2014 && parseInt(selectedStateCode)===36 && value.properties.state_code === 28 && [532, 533, 534, 535, 536, 537, 538, 539, 540, 541].includes(value.properties.district_code)){
                districtnames[value.properties.district_code] = value.properties.district_name;
                district_statenames[value.properties.district_code] = 'Telangana';
            }
            else if(selectedYear>=2014 && parseInt(selectedStateCode)===28 && value.properties.state_code === 28 ){
                let checkk = [532, 533, 534, 535, 536, 537, 538, 539, 540, 541].includes(value.properties.district_code)
                if(!checkk){
                    districtnames[value.properties.district_code] = value.properties.district_name;
                    district_statenames[value.properties.district_code] = 'Andhra Pradesh';
                }
            }
            else if(selectedYear>=2020 && parseInt(selectedStateCode)===38 && value.properties.state_code === 1 ){
                let checkk = [3,4].includes(value.properties.district_code)
                if(checkk){
                    districtnames[value.properties.district_code] = value.properties.district_name;
                    district_statenames[value.properties.district_code] = 'Ladakh';
                }
            }
            else if(selectedYear>=2020 && parseInt(selectedStateCode)===1 && value.properties.state_code === 1 ){
                let checkk = [3,4].includes(value.properties.district_code)
                if(!checkk){
                    districtnames[value.properties.district_code] = value.properties.district_name;
                    district_statenames[value.properties.district_code] = 'Jammu & Kashmir';
                }
            }
            else if (parseInt(selectedStateCode) === 50 && selectedYear >= 2021) {
              // Handle Dadra & Nagar Haveli and Daman & Diu districts
              // Include districts from both former territories (codes 25 and 26)
              let checkk = [25, 26].includes(value.properties.state_code)
                if(checkk){
                    districtnames[value.properties.district_code] = value.properties.district_name;
                    district_statenames[value.properties.district_code] = 'Dadra & Nagar Haveli and Daman & Diu';
                }
            }
            else if(value.properties.state_code === parseInt(selectedStateCode)){
                districtnames[value.properties.district_code] = value.properties.district_name;
                district_statenames[value.properties.district_code] = value.properties.state_name;
            }
        })
    }
    else{
        /* iterates over districtmap_json file and districtnames object is created with district_code(as keys) and corresponding districtnames(as values).
        simultaneously creates another district_statenames object with district_code(as keys) and state_name(as values) */
        Object.keys(districtmap_json.objects.districts_2011.geometries).forEach(key => {
            let value = districtmap_json.objects.districts_2011.geometries[key];
            districtnames[value.properties.district_code] = value.properties.district_name;
            district_statenames[value.properties.district_code] = value.properties.state_name;
        })
    }
    return {"statenames": statenames, "district_statenames": district_statenames, "districtnames": districtnames}
}

/**
 * Processes visualization data based on type of visualization (Map, Bar or Line) and view type (district or state)
 * Data Manipulation:
 * - Filters data for state/district view
 * - Handles different visualization types (Line, Map, Bar)
 * - Processes India-level data
 * - Removes duplicates using lodash
 * 
 * @param {Object} params - Parameters for data processing
 * @param {Object} params.json - Raw data
 * @param {string} params.visualization - Type of visualization
 * @param {string} params.selected_district_state_code - Selected state/district code
 * @param {Object} params.districtNames - District name mappings
 * @param {Object} params.stateNames - State name mappings
 * @param {string} params.viewType - View level (State/District)
 * @param {Function} params.setIndiaValue - Callback to set India-level value
 * @returns {Object} - Processed data for visualization
 */
const parseDataFunc = async ({ json, visualization, selected_district_state_code='', districtNames, stateNames, viewType=Constants.State, setIndiaValue }) => {
    var viewjson, india_json, state_linedata;
    if(!json['data'].length){
        alert("Data for chosen combination of filters is not available. Resetting filters, please wait.");
    }	
    else{
        /* if stc!=0 and dtc==0, it means it is the data for the whole state */
        /* if stc!=0 and dtc!=0, it means it is the data for a district */
        if(visualization === Constants.Line){
            if(viewType===Constants.District){
                viewjson = await json['data'].filter(function(obj) {
                    if(selected_district_state_code){
                        return (obj.stc !== 0 && obj.dtc !== 0 && obj.stc === parseInt(selected_district_state_code));
                    }
                    else{
                        return (obj.stc !== 0 && obj.dtc !== 0);
                    }
                });
                india_json = await json['data'].filter(function(obj) {
                    if(selected_district_state_code===''){
                        return (obj.stc !==0 && obj.dtc === 0) ||
                                (obj.stc === 0 && obj.dtc === 0);
                    }
                    else{
                        if(obj.stc === parseInt(selected_district_state_code) && obj.dtc === 0) return true;
                        else return (obj.stc === 0 && obj.dtc === 0);
                    }
                });
            }
            else{
                viewjson = await json['data'].filter(function(obj) {
                    return (obj.stc !== 0 && obj.dtc === 0);
                });
                india_json = await json['data'].filter(function(obj) {
                    return (obj.stc === 0 && obj.dtc === 0);
                });
                setIndiaValue(parseFloat(india_json[0]?.value).toFixed(2));
            }
        }	
        else{
            if(viewType===Constants.District){
                viewjson = await json['data'].filter(function(obj) {
                    return (obj.stc !== 0 && obj.dtc !== 0);
                });
                viewjson = _.uniqWith(viewjson, (arrVal, othVal) => arrVal.dtc === othVal.dtc);
                india_json = await json['data'].filter(function(obj) {
                    if(selected_district_state_code===''){
                        return (obj.stc !==0 && obj.dtc === 0) ||
                                (obj.stc === 0 && obj.dtc === 0);
                    }
                    else{
                        if(obj.stc === parseInt(selected_district_state_code) && obj.dtc === 0) return true;
                        else return (obj.stc === 0 && obj.dtc === 0);
                    }
                });
            }
            else{
                viewjson = await json['data'].filter(function(obj) {
                    return (obj.stc !== 0 && obj.dtc === 0);
                });
                viewjson = _.uniqWith(viewjson, (arrVal, othVal) => arrVal.stc === othVal.stc);
                india_json = await json['data'].filter(function(obj) {
                    return (obj.stc === 0 && obj.dtc === 0);
                });
                setIndiaValue(parseFloat(india_json[0]?.value).toFixed(2));
            }
        }

        state_linedata = viewjson;
        /* the return type of every visualization type is different and hence considered seperately */
        if((visualization === Constants.Map) || (visualization === Constants.Bar)){
            if(json && viewjson && india_json)
                return {"chartInfo": json, "viewJson": viewjson, "indiaJson": india_json}
        }
        else if(visualization === Constants.Line){
            /* if the visualization type is line, then instead of returning geographies for all states or districts, we return for some pre-selected states or starting 5 districts */
            let temp=[];
            if(viewType===Constants.State) temp = ["21_West Bengal" ,"34_Kerala", "9_NCT of Delhi", "10_Rajasthan", "35_Tamil Nadu", "0_India"]
            else{
                await Object.keys(districtNames).forEach((key, i) => {
                    if(i<5) temp.push(key.toString()+"_"+districtNames[key].toString());
                    else return;
                })
            } 
            let linedata = await selectGeographies(temp, viewType)
            return {"chartInfo": json, "viewJson": viewjson, "indiaJson": india_json, "state_linedata": state_linedata, "linedata": linedata};
        }	
    }
}

/**
 * Selects and formats geographic data for visualization
 * Data Manipulation:
 * - Converts geographic identifiers to numeric codes
 * - Creates mappings between codes and names
 * - Handles both state and district level selections
 * 
 * @param {Array} temp - Array of geographic identifiers
 * @param {string} selectedlevel - Selected view level (State/District)
 * @returns {Object} - Processed geographic data with mappings
 */
const selectGeographies = async(temp, selectedlevel) => {
    var geographies = {};
    var i = 0;
    if(selectedlevel === Constants.State){	
        await temp.forEach((obj) => {
            var spliited_id =  obj.split("_");
            geographies[i++] = parseInt(spliited_id[0]);
        })
        if(temp.length>0){
            return {"geographies": geographies};
        }	
        else{
            alert('Please choose geographies.');
        }
    }  	
    else if(selectedlevel === Constants.District){
        await temp.forEach((obj) => {
            var spliited_id =  obj.split("_");
            geographies[i++] = parseInt(spliited_id[0]);
        })
        if(temp.length>0) return {"geographies": geographies};
    }	
}

function _isContains(json, value) {
    let contains = false;
    Object.keys(json).some(key => {
        contains = typeof json[key] === 'object' ? _isContains(json[key], value) : json[key] === value;
        return contains;
    });
    return contains;
}

export {selectGeographies, parseEntityNames, parseDataFunc, parseFilters};